import React, {useEffect} from "react";
import {BrowserRouter, Navigate, Route, Routes} from 'react-router-dom';
import Intro from 'views/Intro';
import Main, {BenefitsDetail, BenefitsTab} from 'views/Main';
import {
	ApplyComplet,
	ApplyRequirements,
	CardBenefit,
	CardDeliverySelect, CardDesignSelect,
	CardReceiveMethodSelect,
	CustomerInfo,
	DeliveryBranch,
	DeliveryInput,
	DeliveryInputSearch,
    DeliveryInputConfirm,
	DepositCardIssuanceFee,
	EventComplet,
	IdcardSelect,
	IdcardUpload,
	MobileVerify,
	MobileVerifyConfirm,
	PincodeVerify,
	ProposerInfo,
	TermsDetail,
	TermsList
} from 'views/Apply';
import {ApprovalDetail, ApprovalList, NonPaymentFeeList} from 'views/Approval';
import {
	CardAutoDebit,
	CardMonthlyFeeTypeView,
	CardNumberView,
	CardPendingFeeView,
	CardVerify,
	MonthlyFeeAutoDebit,
	MonthlyFeeHistory,
	PasswordChange,
	TemporaryFreeze,
	TerminateNotice,
	TerminateReason,
	TerminateResult
} from 'views/CardManage';
import {ProductDetail as NologinProductDetail, ProductList as NologinProductList} from 'views/Nologin';
import {ProductDetail, ProductList, ProductTab} from 'views/Product';
import {NotFound} from 'views/Error';
import {AppTest as AppTestView} from './views';
import {useLocation} from "react-router";
import OldBenefits from 'views/Main/OldBenefits';

const ScrollToTop: React.FC = () => {
	const {pathname} = useLocation();
	
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);
	
	return null;
}

const App: React.FC = () => {
	return (
		<BrowserRouter>
			<ScrollToTop/>
			<Routes>
				<Route path="/">
					<Navigate to="/intro?pid=&languageCode=ko&deviceType=2&trafficYn=N&inviterCode=" replace={true}/>
				</Route>
				
				{/* TEST영역 */}
				<Route element={<AppTestView/>} path="appTest"/>
				
				
				{/* 개발영역 */}
				{/* 인트로 */}
				<Route element={<Intro/>} path="/intro"/>
				
				{/* 메인 */}
				<Route element={<Main/>} path="/main"/>
				<Route element={<BenefitsDetail/>} path="/main/benefits/:cardProductCode"/>
				<Route element={<BenefitsTab/>} path="/main/benefitsTab/:cardProductCode"/>
				<Route element={<OldBenefits/>} path="/main/oldBenefits/:cardProductCode"/>

				{/* 상품 */}
				<Route element={<ProductList/>} path="/product"/>
				<Route element={<ProductTab/>} path="/product/tab"/>
				<Route element={<ProductDetail/>} path="/product/:cardProductCode"/>
				
				{/* 발급 */}
				<Route path="/apply">
					<Route element={<ApplyRequirements/>} path="step0"/>
					<Route element={<TermsList/>} path="step1"/>
					<Route element={<TermsDetail/>} path="step1/:agreeType"/>
					<Route element={<PincodeVerify/>} path="step2"/>
					<Route element={<MobileVerify/>} path="step3"/>
					<Route element={<MobileVerifyConfirm/>} path="step3/confirm"/>
					<Route element={<IdcardSelect/>} path="step4"/>
					<Route element={<IdcardUpload/>} path="step4/upload"/>
					<Route element={<CustomerInfo/>} path="step5"/>
					<Route element={<ProposerInfo/>} path="step5/proposer"/>
					<Route element={<CardReceiveMethodSelect/>} path="step6/method"/>
					<Route element={<CardDeliverySelect/>} path="step6"/>
					<Route element={<DeliveryBranch/>} path="step6/branch"/>
					<Route element={<DeliveryInput/>} path="step6/input"/>
					<Route element={<DeliveryInputSearch/>} path="step6/input/search"/>
					<Route element={<DeliveryInputConfirm/>} path="step6/input/confirm"/>
					<Route element={<CardMonthlyFeeTypeView/>} path="step7"/>
					<Route element={<ApplyComplet/>} path="complet"/>
					<Route element={<EventComplet/>} path="complet/:cardProductCode"/>
					<Route element={<DepositCardIssuanceFee/>} path="depositCardIssuanceFee"/>
					<Route element={<CardDesignSelect/>} path="cardDesignSelect"/>
					<Route element={<CardBenefit/>} path="cardBenefit"/>
				</Route>
				
				{/* 승인내역 */}
				<Route element={<ApprovalList/>} path="/approval"/>
				<Route element={<ApprovalDetail/>} path="/approval/detail"/>
				<Route element={<NonPaymentFeeList/>} path="/approval/nonPaymentFee"/>
				
				{/* 카드관리 */}
				<Route path="/manage">
					<Route element={<PasswordChange/>} path="password/change"/>
					<Route element={<CardVerify/>} path="card/verify/:type"/>
					<Route element={<TemporaryFreeze/>} path="card/freeze"/>
					<Route element={<CardAutoDebit/>} path="card/debit"/>
					<Route element={<PincodeVerify/>} path="pincode/verify"/>
					<Route element={<CardNumberView/>} path="card/number"/>
					<Route element={<MonthlyFeeAutoDebit/>} path="monthlyFee/debit"/>
					<Route element={<MonthlyFeeHistory/>} path="monthlyFee/history"/>
					<Route element={<CardMonthlyFeeTypeView/>} path="card/monthlyFeeType"/>
					<Route element={<CardPendingFeeView/>} path="card/pendingFee"/>
				</Route>
				
				{/* 해지 */}
				<Route path="/terminate">
					<Route element={<TerminateNotice/>} path="step1"/>
					<Route element={<TerminateReason/>} path="step2"/>
					<Route element={<TerminateResult/>} path="result/:result"/>
				</Route>
				
				{/* 비로그인 상품 */}
				<Route path="/nologin">
					<Route element={<NologinProductList/>} path="product"/>
					<Route element={<NologinProductDetail/>} path="product/:cardProductCode"/>
				</Route>
				
				{/* Error */}
				<Route element={<NotFound/>} path="*"/>
			</Routes>
		</BrowserRouter>
	);
}

export default App;